import { isNonEmpty, NonEmpty } from './NonEmpty';

/** Identical to String::split, but guarantees that the returned array is non-empty. */
export const safeSplit = (input: string, splitter: string | RegExp): NonEmpty<string[]> => {
  const parts = input.split(splitter);
  return isNonEmpty(parts) ? parts : [input];
};
